<script setup>
import { ref, reactive, onMounted } from "vue";
import { useTheme } from "vuetify";
import { appBarStore } from "@/stores/appBar";
import { apiQuery } from "@/api/j24api";
import AlertsList from "@/components/AlertsList.vue";
import MdmServers from "../elaadmin/MdmServers.vue";
import DevicesList from "./components/DevicesList.vue";
import DeviceView from "./components/DeviceView.vue";
import BreadcrumbSeperator from "@/components/BreadcrumbSeperator.vue";
import { storeToRefs } from "pinia";
import { patch24Store } from "@/stores/patch24";
const patch24 = patch24Store();
const { devices, selectedLicense, appsList } = storeToRefs(patch24);

const appBar = appBarStore();
const theme = useTheme();
const loading = ref(false);
const alerts = ref([]);
//const devices = reactive([]);
const selectedView = ref("Devices");
const selectedDevice = ref({});

onMounted(async () => {
  theme.global.name.value = "jigsawNew";
  // if (appBar.selected) {
  //   await getLicense(appBar.selected);
  // }
  if (devices.value.length === 0 && appBar.selected) {
    await getDevices();
  }
  if (appsList.value.length === 0 && appBar.selected) {
    await getAppsList();
  }
});

const randomKeys = ref({
  deviceView: 0,
});

async function getAppsList() {
  try {
    const result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "getAppsList",
      licenseId: appBar.selected,
    });
    if (result.length) {
      appsList.value.length = 0;
      appsList.value.push(...result);
    } else {
      alerts.value.push({
        type: "error",
        message: "Error getting apps",
        closable: true,
      });
      console.log("Empty apps list returned");
    }
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error getting apps",
      closable: true,
    });
    console.log("Error getting apps x", error);
  }
}

function updateRandom(key) {
  randomKeys.value[key] = Math.random();
}

appBar.$subscribe(() => {
  console.log("Appbar changed", appBar.$state);
  if (appBar.selected) {
    getLicense(appBar.selected);
    //getDevices();
  }
  if (selectedView.value !== "Devices") {
    selectedView.value = "Devices";
  }
});

async function refreshDevices() {
  devices.value.length = 0;
  await getDevices();
}

async function getLicense(id) {
  loading.value = true;
  try {
    var result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "getPatchingLicense",
      id: id,
    });
    if (result.length) {
      selectedLicense.value = result[0];
      getDevices();
      getAppsList();
    } else {
      alerts.value.push({
        type: "error",
        message: "Error getting license",
        closable: true,
      });
    }
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error getting license",
      closable: true,
    });
  }
}

async function getDashboardData() {
  try {
    var dashboard;
    var devices;
    if (selectedLicense.value.mdmServerID) {
      // First get dashboard data
      const dashboard = await apiQuery("ELA", "cmd24/query", {
        dataRequested: "dashboard",
        maxage: 86400,
        mdmServerId: selectedLicense.value.mdmServerID,
      });
      if (dashboard.content?.macOSAll?.records) {
        const devicesResult = await apiQuery("ELA", "cmd24/query", {
          dataRequested: "dashboardDetail",
          id: dashboard.content.macOSAll.records,
          mdmServerId: selectedLicense.value.mdmServerID,
        });
        if (devicesResult.content.length) {
          devices.value = [];
          devices.value.push(...devicesResult.content);
        }
      }
    }
    return {
      devices: devices,
      dashboard: dashboard,
    };
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error getting devices",
      closable: true,
    });
  }
}

async function getPatchDevices() {
  try {
    console.log("selectedLicense", selectedLicense);
    let result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "getDevices",
      id: selectedLicense.value._id,
      minimal: true,
    });
    if (result.length) {
      return result;
    }
  } catch (error) {
    alerts.value.push({
      type: "error",
      message: "Error getting devices",
      closable: true,
    });
  }
}

async function getDevices() {
  loading.value = true;
  if (devices.value.length) {
    loading.value = false;
    return;
  }
  // Run getDashboardData and getPatchDevices in parallel
  const [patchDevices] = await Promise.all([getPatchDevices()]);
  if (patchDevices) {
    // Process the data as needed
    console.log("Patch Devices:", patchDevices);

    devices.value.length = 0;
    devices.value.push(...processDevices(patchDevices));

    // let processed = processDevices(dashboardData.devices, patchDevices);
    // console.log("Processed Devices:", processed);
    // devices.length = 0;
    // devices.push(...processed);
  } else {
    alerts.value.push({
      type: "error",
      message: "Error getting devices",
      closable: true,
    });
  }
  loading.value = false;
}

function processDevices(pdevices) {
  let result = [];
  pdevices.forEach((device) => {
    var newDevice = device;
    newDevice.Computer_Name = device.computerName;
    newDevice.Serial_Number = device.serial;
    newDevice.Model = device.stats?.HardwareStats?.computerModel || "";
    newDevice.patchLastContact = device.lastContact;
    newDevice.updatesAvailableCount = device.updatesAvailableCount;

    // newDevice.updatesAvailable = device.updatesAvailable?.length
    //   ? device.updatesAvailable
    //   : 0;
    // newDevice.patchLastContact = device.lastContact;
    // newDevice.updatesAvailableCount = device.updatesAvailable?.length
    //   ? device.updatesAvailable.length
    //   : 0;
    result.push(newDevice);
  });
  return result;
}

function processDevicesInsights(devices, pdevices) {
  let result = [];
  devices.forEach((device) => {
    let found = pdevices.find(
      (pdevice) => pdevice.serial === device.Serial_Number
    );
    if (found) {
      var newDevice = device;
      newDevice.patchData = found;
      newDevice.updatesAvailable = found.updatesAvailable?.length
        ? found.updatesAvailable
        : 0;
      newDevice.patchLastContact = found.lastContact;
      newDevice.updatesAvailableCount = found.updatesAvailable?.length
        ? found.updatesAvailable.length
        : 0;
      result.push(newDevice);
    }
  });
  return result;
}

function selectDevice(selected) {
  //  console.log(selected);
  selectedDevice.value = selected;
  updateRandom("deviceView");
  selectedView.value = "SelectedDevice";
}
</script>
<template>
  <template v-if="!appBar.selected">
    <v-row>
      <v-col>
        <h1 v-if="appBar.items.length > 1">Select Patching License Above</h1>
        <h1 v-else>Loading please wait...</h1>
      </v-col>
    </v-row>
  </template>
  <template v-else>
    <v-window v-model="selectedView">
      <v-window-item value="Devices">
        <h1 class="ml-1">Devices</h1>
        <DevicesList
          @view="selectDevice"
          @refresh="refreshDevices"
          :devices="devices"
          :loading="loading"
        />
      </v-window-item>

      <v-window-item value="SelectedDevice">
        <div style="display: flex; align-items: center">
          <BreadcrumbEmit label="Devices" @click="selectedView = 'Devices'" />
          <BreadcrumbSeperator />
          <BreadcrumbEmit :label="selectedDevice?.Computer_Name" notLink />
        </div>
        <DeviceView
          :device="selectedDevice"
          :mdmServerId="selectedLicense.mdmServerID"
          :licenseId="selectedLicense._id"
          :key="randomKeys.deviceView"
          @back="selectedView = 'Devices'"
          @backRefresh="(selectedView = 'Devices'), refreshDevices()"
        >
        </DeviceView>
      </v-window-item>
    </v-window>
  </template>
</template>
